//Import asset file(s) used by this module.
import '../../../assets/skins/AudioSubtitleAssets';

import SoundManager from '../../../../lib/html5-software-library/src/ranj/audio/SoundManager';
import AbstractInstaller from "../application/AbstractInstaller";
import AppInstaller from '../application/AppInstaller';
import SkinKeyRegistry from '../ui/SkinKeyRegistry';
import InitializeAudioSubtitlesCommand from './controller/InitializeAudioSubtitlesCommand';
import AudioSubtitleEvent from './event/AudioSubtitleEvent';
import AudioSubtitlePopupMediator from './view/AudioSubtitlePopupMediator';

export default class SoundInstaller extends AbstractInstaller {
    constructor(injector, commands, mediatorMap) {
        super(injector, commands, mediatorMap);

        commands.add(AudioSubtitleEvent.INITIALIZE, InitializeAudioSubtitlesCommand);
        
        injector.mapClass("soundManager", SoundManager, true);

        SkinKeyRegistry.AUDIO_SUBTITLE_POPUP_SKIN = this._mapMediator(AudioSubtitlePopupMediator, lib.AudioSubtitleAssets.AudioSubtitlePopupSkin);

        this._addAssetGroupsToList(AppInstaller.STARTUP_ASSET_GROUPS, "ui_sounds", "shared_scenario_sounds");
    }
}